import { tiresWarranty } from "./tires-warranty-de.i18n";

export const de = {
  tiresWarranty
}
